<template>
    <c-dialog ref="dialog" height="500" width="600" @resolve="editHandle">
        <div style="padding: 15px;">
            <div v-if="multi_map_tip" class="channel-tip">{{ multi_map_tip }}</div>
            <c-table ref="channel_table" border :paging="false" width-resize>
                <c-table-column label="渠道名称" name="channel_name" width="100"></c-table-column>
                <c-table-column label="映射ID" width="100">
                    <template #default="{data}">
                        <c-input name="channel_value" v-model="data.channel_value" :clear="false"></c-input>
                    </template>
                </c-table-column>
                <c-table-column label="映射名称" width="100">
                    <template #default="{data}">
                        <c-input name="channel_value_name" v-model="data.channel_value_name" :clear="false"></c-input>
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    computed: {
        //一对多映射按spv_type白名单展示提示：属性(attribute)、属性值(attribute_value)、质检项(release_parent)、质检项值(release)，其余级别不展示
        //属性/属性值：竖线(|)分隔，两级数量按位次一一对应（如容量→内存+硬盘、6g+128g），不齐发布报错
        //质检项：只以井号(#)分隔展开为多个渠道质检项；用竖线(|)属配置错误（整串解析不出数字），发布报失败；配对还要求质检项与质检项值两边都用#且数量一致
        //质检项值：#分隔为新映射（与所属质检项的#映射数量齐平按位次对应，不齐则排列组合），|分隔为相似项映射（并列挂同一渠道质检项下），同一段内两种不混用
        //未配置映射则该项不推；映射ID为空或不是数字（含#与|混用）算配置错误，各级均发布报失败
        multi_map_tip() {
            let tips = {
                attribute: '属性支持一对多映射，映射ID、映射名称可填多个，多个值之间以竖线(|)分隔；第几个映射ID与属性值映射的第几个一一对应（如容量→内存+硬盘），数量不一致时发布将失败',
                attribute_value: '属性值支持一对多映射，映射ID、映射名称可填多个，多个值之间以竖线(|)分隔；与属性的映射按位次一一对应（如6g+128g→内存6g+硬盘128g），数量不一致时发布将失败',
                release_parent: '质检项支持一对多映射，映射ID、映射名称可填多个，多个值之间只能以井号(#)分隔（竖线(|)是属性/属性值与质检项值相似项映射的写法，质检项用|会被判为映射ID不是数字、发布失败）；其下质检项值也按#配置且两边数量一致时按位次一一对应（第几个值只挂第几个渠道质检项），其余情况每个渠道质检项各挂全部选中值；映射ID为空或不是数字时发布将失败',
                release: '质检项值支持两种一对多映射：以井号(#)分隔为新映射，所属质检项也按#配置且两边数量一致时按位次一一对应，否则每个渠道质检项都挂该值；以竖线(|)分隔为相似项映射，并列挂在同一渠道质检项下；同一段内#与|不可混用，映射ID为空或不是数字时发布将失败'
            };
            return tips[this.spvType] || '';
        }
    },

    data() {
        return {
            spvType: '',
            spvId: 0
        }
    },

    methods: {
        //获取渠道信息列表
        queryChannelList(spv_type, spv_id) {
            this.request({
                url: '/spv/channel/list',
                data: {
                    spv_type: spv_type,
                    spv_id: spv_id
                },
                loading: true,
                success: data => {
                    if (data && data.length > 0) {
                        this.$refs.channel_table.setData(data);
                    } else {
                        this.$refs.channel_table.clear();
                    }
                }
            });
        },
        /*********打开编辑框，初始化**********/
        open(data, name, spv_type) {
            console.log(data);
            this.spvType = spv_type;
            if (data) {
                this.spvId = data.id;
                this.queryChannelList(spv_type, data.id);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: '渠道映射 - ' + name
            });
        },

        /*******添加、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            let channel_list = this.$refs.channel_table.getRow().map((item, index) => {
                return item.data;
            })
            this.request({
                url: '/spv/channel/edit',
                data: {
                    spv_type: this.spvType,
                    spv_id: this.spvId,
                    channel_list: channel_list,
                },
                loading: true,
                success: data => {
                    next();
                    this.$message({
                        message: '编辑成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.channel-tip
    font-size 13px
    color #999
    line-height 18px
    margin-bottom 8px
</style>